import { ApiRequest, fetchDataFromAPITyped } from '../services/api-requests';
import {
  PaymentDetails,
  CheckoutSession,
  PaymentSheetParams,
} from '../models/payment-model';

export const getPaymentDetails = async (orderId: string) => {
  const apiQuery: ApiRequest = {
    route: 'payments/details',
    request: {
      method: 'GET',
      entity: 'payments',
      body: null,
      searchParams: new URLSearchParams({ orderId: orderId }),
    },
  };
  return await fetchDataFromAPITyped<PaymentDetails>(apiQuery);
};

export const createCheckoutSession = async () => {
  const apiQuery: ApiRequest = {
    route: `payments/subscriptions/host`,
    request: {
      method: 'POST',
      entity: 'payments',
      body: undefined,
    },
  };
  return await fetchDataFromAPITyped<CheckoutSession>(apiQuery);
};

export const fetchPaymentSheetParams = async () => {
  const apiQuery: ApiRequest = {
    route: `payments/mobile-payment-sheet-session`,
    request: {
      method: 'POST',
      entity: 'payments',
      body: undefined,
    },
  };
  return await fetchDataFromAPITyped<PaymentSheetParams>(apiQuery);
};
